module.exports = __webpack_public_path__ + "img/cuccioli.53303591.png";